import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  loadDeliveryChargesListRequested,
  storeDeliveryDetailRequested,
  updateDeliveryDetailRequested,
} from "store/delivery-fees/deliverySlice";

export function useLoadDeliveryChargesList() {
  const dispatch = useDispatch();
  const onLoadDeliveryChargesList = useCallback(async () => {
    await dispatch(loadDeliveryChargesListRequested({}));
  }, [dispatch]);

  useEffect(() => {
    onLoadDeliveryChargesList();
  }, [onLoadDeliveryChargesList]);
  return { onLoadDeliveryChargesList };
}

export function useStoreDeliveryDetail() {
  const dispatch = useDispatch();
  const onStoreDeliveryDetail = useCallback(
    async (values: any) => {
      await dispatch(storeDeliveryDetailRequested(values));
    },
    [dispatch]
  );
  return { onStoreDeliveryDetail };
}

export function useUpdateDeliveryDetail() {
  const dispatch = useDispatch();
  const onUpdateDeliveryDetail = useCallback(
    async (values: any) => {
      await dispatch(updateDeliveryDetailRequested(values));
    },
    [dispatch]
  );
  return { onUpdateDeliveryDetail };
}

// export function useLoadAssignDeliveryDetail(id: any) {
//   const dispatch = useDispatch();
//   const onLoadAssignDeliveryDetail = useCallback(async () => {
//     await dispatch(loadAssignDeliveryDetailRequested(id));
//   }, [dispatch, id]);
//   useEffect(() => {
//     onLoadAssignDeliveryDetail();
//   }, [onLoadAssignDeliveryDetail]);
//   return { onLoadAssignDeliveryDetail };
// }
